import { Meta } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from './app-config.service';
import get from 'lodash.get';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/platform-browser";
import * as i3 from "@angular/common/http";
import * as i4 from "./app-config.service";
var SCHEMA_GENERATED_ID = 'schema-generated';
var SCHEMA_EDITOR_ATTRIBUTE = 'data-schema';
var SEOService = /** @class */ (function () {
    function SEOService(dom, meta, http, appConfigService) {
        this.dom = dom;
        this.meta = meta;
        this.http = http;
        this.appConfigService = appConfigService;
        this.isInitialPage = true;
        this.structuredDataRequest = 0;
    }
    SEOService.prototype.addTags = function (metaData) {
        var _this = this;
        var meta = this.mapServerModel(metaData);
        meta.forEach(function (metaItem) {
            var selector = metaItem.name ? "name=" + metaItem.name : "property='" + metaItem.property + "'";
            _this.meta.updateTag(metaItem, selector);
        });
        this.setEditorMicrodata(get(metaData, 'microdata.value', ''));
    };
    /**
     * The landing page gets its generated JSON-LD from the server (#schema-generated),
     * so it is only fetched again after client-side navigation.
     */
    SEOService.prototype.updateStructuredData = function (url) {
        var _this = this;
        if (this.isInitialPage) {
            this.isInitialPage = false;
            return;
        }
        var request = ++this.structuredDataRequest;
        this.removeScripts("#" + SCHEMA_GENERATED_ID);
        var absoluteUrl = url.indexOf('://') > -1 ? url : this.appConfigService.getHostName() + url;
        this.http.get('/ubaseline/api/bgStructuredData/getByUrl', { params: { url: absoluteUrl } })
            .subscribe(function (json) {
            if (!json || request !== _this.structuredDataRequest)
                return;
            _this.dom.head.appendChild(_this.createJsonLdScript(json, { id: SCHEMA_GENERATED_ID }));
        }, function () { });
    };
    SEOService.prototype.setEditorMicrodata = function (value) {
        var _this = this;
        this.removeScripts("script[" + SCHEMA_EDITOR_ATTRIBUTE + "]");
        var html = this.decodeMicrodata(value);
        if (!html)
            return;
        var container = this.dom.createElement('div');
        container.innerHTML = html;
        var scripts = Array.from(container.querySelectorAll('script[type="application/ld+json"]'));
        scripts.forEach(function (script) {
            var _a;
            var json = (script.textContent || '').trim();
            if (json) {
                _this.dom.body.appendChild(_this.createJsonLdScript(json, (_a = {}, _a[SCHEMA_EDITOR_ATTRIBUTE] = 'editor', _a)));
            }
        });
    };
    // The microdata property is stored JSON-encoded (the server renders it through Json.Decode).
    SEOService.prototype.decodeMicrodata = function (value) {
        if (!value)
            return '';
        var trimmed = value.trim();
        if (trimmed.charAt(0) !== '"')
            return trimmed;
        try {
            return JSON.parse(trimmed);
        }
        catch (_a) {
            return '';
        }
    };
    SEOService.prototype.createJsonLdScript = function (json, attributes) {
        var script = this.dom.createElement('script');
        script.type = 'application/ld+json';
        Object.keys(attributes).forEach(function (name) { return script.setAttribute(name, attributes[name]); });
        script.textContent = json;
        return script;
    };
    SEOService.prototype.removeScripts = function (selector) {
        Array.from(this.dom.querySelectorAll(selector)).forEach(function (el) { return el.remove(); });
    };
    SEOService.prototype.addCanonicalURL = function (url) {
        var link = this.dom.querySelector('[rel="canonical"]');
        if (!link) {
            link = this.dom.createElement('link');
            link.setAttribute('rel', 'canonical');
            this.dom.head.appendChild(link);
        }
        var href = url.indexOf("://") > -1 ? url : this.appConfigService.getHostName() + url;
        link.setAttribute('href', href);
    };
    SEOService.prototype.mapServerModel = function (metaData) {
        var meta = [];
        if (!metaData)
            return meta;
        if (metaData.metaTitle)
            meta.push({ name: 'title', content: metaData.metaTitle.value || '' });
        if (metaData.metaDescription)
            meta.push({ name: 'description', content: metaData.metaDescription.value || '' });
        if (metaData.socialTitle)
            meta.push({ property: 'og:title', content: metaData.socialTitle.value || '' });
        if (metaData.socialDescription)
            meta.push({ property: 'og:description', content: metaData.socialDescription.value || '' });
        if (metaData.socialImage)
            meta.push({ property: 'og:image', content: get(metaData, "socialImage.value.sources[0].srcSet", '') });
        return meta;
    };
    SEOService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SEOService_Factory() { return new SEOService(i0.ɵɵinject(i1.DOCUMENT), i0.ɵɵinject(i2.Meta), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(i4.AppConfigService)); }, token: SEOService, providedIn: "root" });
    return SEOService;
}());
export { SEOService };
